import * as opt from "lib/opt"
Map.prototype.Values = function <K, V>(this: Map<K, V>): V[] {
	return Array.from(this.values())
}

Map.prototype.Keys = function <K, V>(this: Map<K, V>): K[] {
	return Array.from(this.keys())
}

Map.prototype.ToObject = function <K extends string, V>(this: Map<K, V>): Record<K, V> {
	const obj = {} as Record<K, V>
	this.forEach((value, key) => {
		obj[key] = value
	})
	return obj
}

Map.prototype.Get = function <K, V>(this: Map<K, V>, key: K): Opt<V> {
	return opt.FromNullable(this.get(key))
}

Map.prototype.Delete = function <K, V>(this: Map<K, V>, key: K): Opt<V> {
	const value = this.Get(key)
	if (value.IsSome()) {
		this.delete(key)
	}
	return value
}

// Override the default Set method to return the old value
Map.prototype.Set = function <K, V>(this: Map<K, V>, key: K, value: V): Opt<V> {
	const oldValue = this.get(key)
	this.set(key, value)
	return opt.FromNullable(oldValue)
}

// Add static methods to the Map constructor

Map.FromObject = function <K extends string, V>(obj: Record<K, V>): Map<K, V> {
	return new Map(Object.entries(obj) as [K, V][])
}

Map.prototype.Clear = function <K, V>(this: Map<K, V>): void {
	this.clear()
}

Map.prototype.Copy = function <K, V>(this: Map<K, V>): Map<K, V> {
	return new Map(this)
}

Map.prototype.Len = function <K, V>(this: Map<K, V>): int {
	return this.size
}

Map.prototype.Contains = function <K, V>(this: Map<K, V>, key: K): bool {
	return this.has(key)
}

Map.prototype.Range = function <K, V>(
	this: Map<K, V>,
	fn: (key: K, value: V) => bool | void
): void {
	for (const [key, value] of this.entries()) {
		const result = fn(key, value)
		if (result === false) break
	}
}
